// extracted by mini-css-extract-plugin
module.exports = {"mainButton":"style_mainButton__3EF82","drakButton":"style_drakButton__39dcd"};